import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Tabs.module.sass';

export const Tabs = (props) => {
  const { t } = useTranslation();

  const options = [
    {
      item: 'popular',
      translation: t('escuela.tabs.popular'),
    },
    {
      item: 'new',
      translation: t('escuela.tabs.new'),
    },
  ];

  return (
    <div className={styles.Tabs}>
      <ul>
        {options.map((option, index) => (
          <li key={`tab-${index}`}>
            <button
              type="button"
              className={props.activeTab === option.item && styles.Active}
              onClick={() => props.handleClick(option.item)}
            >
              {option.translation}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
